import React from 'react';

export const Spinner = () => {
    return <div style={{ padding: '10px', display: 'flex' }}>
        <div className="spinner-container">
            <div className="loading-spinner" />
        </div>
    </div>;
}
